import { render, staticRenderFns } from "./Sendpassword.vue?vue&type=template&id=b289c57c"
import script from "./Sendpassword.vue?vue&type=script&lang=js"
export * from "./Sendpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports